<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">礼物管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>赠送对象：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editGiftDialog(-1)">创建礼物</el-button>
          <el-button type="success" v-if="switchState == 0" @click="giftSwitch(1)" v-loading="switchLoading">开启礼物系统</el-button>
          <el-button type="danger" v-if="switchState == 1" @click="giftSwitch(0)" v-loading="switchLoading">关闭礼物系统</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="" label="赠送对象" v-if="checkColList.indexOf('赠送对象') > -1" >
            <template #default="scope">
              {{scope.row.sex == 0?'通用':scope.row.sex == 1?'男':scope.row.sex == 2?'女':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="礼物图片" v-if="checkColList.indexOf('礼物图片') > -1">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.img"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column property="giftName" label="礼物名称" v-if="checkColList.indexOf('礼物名称') > -1"></el-table-column>
          <el-table-column property="gold" label="价格" v-if="checkColList.indexOf('价格') > -1"></el-table-column>
          <el-table-column property="giftMax" label="赠送次数/天/用户" v-if="checkColList.indexOf('赠送次数/天/用户') > -1"></el-table-column>
          <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              {{scope.row.state == 0?'待启用':scope.row.state == 1?'已启用':scope.row.state == 2?'已停用':''}}
              <p style="color:red;">{{scope.row.isSys == 1?'系统礼物':''}}</p>
              <p style="color:#3a8ee6;">{{scope.row.isDefault == 1?'默认选项':''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="360">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editGiftDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.$index, scope.row, 1)">启用</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="danger" v-if="scope.row.state == 1" @click="updateState(scope.$index, scope.row, 2)">停用</el-button>
                <el-button type="primary" size="small" v-if="pageDataList[scope.$index].isSys == 0" @click="updateSys(scope.$index,1)" v-loading="pageDataList[scope.$index]['updateSysLoading']">设为系统礼物</el-button>
                <el-button type="warning" size="small" v-if="pageDataList[scope.$index].isSys == 1" @click="updateSys(scope.$index,0)" v-loading="pageDataList[scope.$index]['updateSysLoading']">取消系统礼物</el-button>
                <el-button type="primary" plain size="small" v-if="pageDataList[scope.$index].isDefault == 0" @click="updateDefault(scope.$index,1)" v-loading="pageDataList[scope.$index]['updateDefaultLoading']">设为默认选项</el-button>
                <el-button type="warning" plain size="small" v-if="pageDataList[scope.$index].isDefault == 1" @click="updateDefault(scope.$index,0)" v-loading="pageDataList[scope.$index]['updateDefaultLoading']">取消默认选项</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import { getGiftPageList, updateGiftState, updateDefaultGift, updateSysGift, getCommonSysParam, updateConfigSysParam } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import GiftManageDialog from "./components/GiftManageDialog";

export default {
  name: "GiftManage",
  components: { BtnGroup },
  data() {
    return {

      sexArray: [
        {label: '不限', value: -1},
        {label: '通用', value: 0},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,


      stateArray: [
        {label: '不限', value: -1},
        {label: '待启用', value: 0},
        {label: '已启用', value: 1},
        {label: '已停用', value: 2},
      ],
      state: 1,

      //刷新组
      colList: ['赠送对象', '礼物图片', '礼物名称', '价格', '赠送次数/天/用户', '排序', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,
      switchLoading: false,
      switchState: 1,
    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.sex = -1;
      this.state = 1;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['type'] = this.type;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getGiftPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editGiftDialog(idx, row) {
      let _title = '';
      let giftForm = {}
      if (idx > -1) {
        _title = '编辑礼物'
        giftForm = Object.assign({}, row);
      }else {
        _title = '创建礼物'
      }
      Dialog.open({
        title: _title,
        component: GiftManageDialog,
        data: {
          giftForm: giftForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateGiftState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.getPage()
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    },

    //设置系统礼物
    updateSys(idx, sys) {
      this.$confirm('确定' + (sys==1?'设置':'取消') + '【' + this.pageDataList[idx]['giftName'] + '】为系统礼物么？').then(() => {
        this.pageDataList[idx]['updateSysLoading'] = true;
        let _this = this;
        let param = {};
        param['id'] = this.pageDataList[idx]['id'];
        param['isSys'] = sys;
        postFormData(updateSysGift, param).then(function(data){
          let {code, msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.pageDataList[idx]['isSys'] = sys
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.pageDataList[idx]['updateSysLoading'] = false;
        })
            .catch(function(response){
              _this.pageDataList[idx]['updateSysLoading'] = false;
            })
      })
          .catch(() => {})
    },

    //设置默认选项
    updateDefault(idx, isDefault) {
      this.$confirm('确定' + (isDefault==1?'设置':'取消') + '【' + this.pageDataList[idx]['giftName'] + '】' + (isDefault==1?'为':'的') + '默认选项么？').then(() => {
        this.pageDataList[idx]['updateDefaultLoading'] = true;
        let _this = this;
        let param = {};
        param['id'] = this.pageDataList[idx]['id'];
        param['sex'] = this.pageDataList[idx]['sex'];
        param['isDefault'] = isDefault;
        postFormData(updateDefaultGift, param).then(function(data){
          let {code, msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.pageDataList[idx]['isDefault'] = isDefault
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.pageDataList[idx]['updateDefaultLoading'] = false;
        })
            .catch(function(response){
              _this.pageDataList[idx]['updateDefaultLoading'] = false;
            })
      })
          .catch(() => {})
    },

    getGiftSwitchState() {
      getFormData(getCommonSysParam).then((data) => {
        let {code, msg} = data;
        if(code == 200){
          this.switchState = data.data.appSysGiftSwitch
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    giftSwitch(state) {
      this.$confirm('确定' + (state==1?'开启':'关闭') + '系统礼物？').then(() => {
        let _this = this;
        _this.switchLoading = true
        let param = {};
        param['type'] = 1;
        param['config'] = state;
        postFormData(updateConfigSysParam, param).then(function(data){
          let {code, msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.switchState = state
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.switchLoading = false;
        })
            .catch(function(){
              _this.switchLoading = false;
            })
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getGiftSwitchState()
  }
}
</script>

<style scoped>

</style>
